module.exports = __webpack_public_path__ + "static/media/title3.1922d6cd.png";